import wenzhou from './wenzhou'

export default Object.assign(wenzhou)


//////////////////
// WEBPACK FOOTER
// ./static/mapPoint/diningPoint/zhejiang/index.js
// module id = null
// module chunks = 